import React from "react";
import Highlight from "./ui/Highlight";

const Highlights = () => {
  return (
    <section id="highlights">
      <div className="container">
        <div className="row">
          <h2 className="section__title">
            Why Choose
            <span className="purple"> Library</span>
          </h2>
          <div className="highlight__wrapper">
            <Highlight
              title="Easy And Quick"
              para="Get access to the book you purchased online instantly."
              icon="bolt"
            />
            <Highlight
              title="10,000+ Books"
              para="Library has books in all your favorite categories."
              icon="book-open"
            />
            <Highlight
              title="Easy And Quick"
              para="Get your hands on popular books for as little as $10."
              icon="tags"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Highlights;
